<template>
  <v-layout>
    <!-- Dialog -->
    <v-dialog v-model="json_data.status" fullscreen transition="dialog-bottom-transition" :overlay="false">
      <v-card style="background-color:#EEEEEE;">
        <v-toolbar dark color="primary">
          <!-- <v-tooltip bottom> -->
          <v-btn icon dark @click="closeDialog">
            <v-icon>close</v-icon>
          </v-btn>
          <!-- <span>{{ $t('close') }}</span>
          </v-tooltip>-->
          <v-toolbar-title>
            {{ json_data.save_type == "create" ? $t("menu.DepartmentCreate") : $t("menu.DepartmentEdit") }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn flat dark @click="json_data.save_type == 'create' ? onSave() : onUpdate()">
            <v-icon>save</v-icon>
            <span class="px-2">{{ json_data.save_type == "create" ? $t("create") : $t("save") }}</span>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container background fluid pa-3>
            <v-layout row wrap pa-3 style="background-color:#fff; margin-top:5px; border-radius:5px;">
              <v-flex xs12>
                <v-form ref="form" v-model="form_valid">
                  <v-layout row wrap>
                    <v-flex md6 sm6 xs12 pa-1>
                      <v-select
                        required
                        :items="branch_list"
                        :label="$t('branch')"
                        item-text="name"
                        item-value="code"
                        v-model="form_model.branchCode"
                        :rules="form_rules.branchCode"
                        hide-details
                      />
                    </v-flex>
                    <!-- <v-flex md6 sm6 xs12 pa-1 /> -->
                    <v-flex md6 sm6 xs12 pa-1 v-if="json_data.save_type == 'create'">
                      <v-text-field
                        :label="$t('code')"
                        v-model="form_model.code"
                        :rules="form_rules.code"
                        append-icon="fas fa-plus-circle"
                        required
                        hide-details
                        @click:append="doNewGuid"
                      />
                    </v-flex>
                    <v-flex md6 sm6 xs12 pa-1 v-if="json_data.save_type != 'create'">
                      <v-text-field :label="$t('code')" v-model="form_model.code" :rules="form_rules.code" readonly required hide-details />
                    </v-flex>
                    <v-flex md6 sm6 xs12 pa-1>
                      <v-text-field :label="$t('menu.DepartmentName')" placeholder="Ex: ตัวอย่างแผนก" v-model="form_model.name" required :rules="form_rules.name" hide-details />
                    </v-flex>
                    <!-- <v-flex md6 sm6 xs12 px-1>
                      <v-select
                        :items="profilePlan"
                        v-model="form_model.shift_profile"
                        :label="$t('menu.WorkPlanList')"
                        item-text="name"
                        item-value="code"
                        hide-details
                        style="margin-top:8px;"
                      />
                    </v-flex>
                    <v-flex md6 sm6 xs12 px-1>
                      <v-select
                        v-model="form_model.conditions_profile"
                        :items="profileConditions"
                        :label="$t('menu.ConditionsList')"
                        item-text="name"
                        item-value="code"
                        hide-details
                      />
                    </v-flex> -->
                    <!-- <v-flex md6 sm6 xs12 pa-1>
                      <v-select :items="profilePlan" :label="$t('Changeplan_dialog_comeworkplan')" item-text="name" item-value="code"
                        hide-details v-model="form_model.plan_code"  required />
                    </v-flex>-->
                    <v-flex md12 sm12 xs12 pa-1>
                      <v-textarea :label="$t('remark')" v-model="form_model.remark" hide-details />
                    </v-flex>
                  </v-layout>
                </v-form>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-layout row wrap>
            <v-flex xs12 text-xs-right pa-3>
              <v-btn color="success" @click="json_data.save_type == 'create' ? onSave() : onUpdate()">
                <v-icon>save</v-icon>
                <span class="px-2">{{ json_data.save_type == "create" ? $t("create") : $t("save") }}</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Snackbar -->
    <v-snackbar v-model="snack_model.status" :timeout="3500" :top="'top'" :color="snack_model.type">
      {{ snack_model.msg }}
      <v-btn dark flat icon @click="snack_model.status = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>
<script>
/* eslint-disable */
import SettingService from "@/services/SettingService";
import Utils from "@/utils/";

export default {
  props: {
    json_data: Object,
  },
  watch: {
    json_data(val) {
      if (val.data != null) {
        this.form_model = val.data;
        if (this.form_model.shift_profile == undefined) {
          this.form_model.shift_profile = "";
        }
        if (this.form_model.conditions_profile == undefined) {
          this.form_model.conditions_profile = "";
        }
      } else {
        this.$refs.form.resetValidation();
        this.doNewGuid();
      }
    },
  },
  data: () => ({
    branch_list: [],
    form_valid: false,
    form_model: {
      code: "",
      name: "",
      remark: "",
      branchCode: "",
      editorCode: localStorage._usercode,
      shift_profile: "",
      conditions_profile: "",
      plan_code: "",
      company_id: localStorage._company_guid,
    },
    form_rules: {
      code: [(v) => !!v || "do not empty."],
      branchCode: [(v) => !!v || "do not empty."],
      name: [(v) => !!v || "do not empty."],
    },
    snack_model: {
      status: "",
      msg: "",
      type: "",
    },
    profilePlan: [],
    profileConditions: [],
  }),
  created: function() {
    this.getProfileBranchList();
    this.doNewGuid();
    this.getProfilePlan();
    this.getProfileConditions();
  },
  methods: {
    closeDialog() {
      this.clearForm();
      this.$emit("close-dialog");
    },
    clearForm() {
      this.form_model = {
        code: "",
        name: "",
        remark: "",
        branchCode: "",
        shift_profile: "",
        conditions_profile: "",
        editorCode: localStorage._usercode,
        plan_code: "",
      };
    },
    doNewGuid() {
      this.form_model.code = Utils.newGuid("D");
    },
    showSnackBar(msg, type) {
      this.snack_model.msg = msg;
      this.snack_model.type = type;
      this.snack_model.status = true;
    },
    getProfileBranchList() {
      SettingService.getProfileBranchList()
        .then((res) => {
          this.branch_list = res.data.content;
        })
        .catch((err) => {
          this.showSnackBar(err.response.data, "error");
        });
    },
    getProfilePlan() {
      this.profilePlan = [];
      this.profilePlan.push({
        code: "",
        name: "ไม่ใช้แผนการทำงาน",
      });
      SettingService.getProfileAllPlan()
        .then((res) => {
          res.data.content.forEach((element) => {
            this.profilePlan.push({
              code: element.code,
              name: element.name,
            });
          });
          //this.profilePlan = res.data.content;
          console.log(this.profilePlan);
        })
        .catch((err) => {
          //console.log(err);
        });
    },
    getProfileConditions() {
      this.profileConditions = [];
      this.profileConditions.push({
        code: "",
        name: "ไม่ใช้เงื่อนไขการหักและรับเงิน",
      });
      SettingService.getProfileConditions()
        .then((res) => {
          res.data.content.forEach((element) => {
            this.profileConditions.push({
              code: element.code,
              name: element.name,
            });
          });
          // this.profileConditions = res.data.content;
          console.log(this.profileConditions);
        })
        .catch((err) => {
          console.log(err);
          this.profileConditions = this.profileConditions;
        });
    },
    onSave() {
      console.log(this.form_model);
      if (this.form_valid) {
        this.form_model.company_id = localStorage._company_guid;
        SettingService.createDepartment(this.form_model)
          .then((res) => {
            this.showSnackBar("save success", "success");
            this.closeDialog();
          })
          .catch((err) => {
            this.showSnackBar("ไม่สามารถบันทึกแผนกซ้ำกันในสาขาได้", "error");
          });
      }
    },
    onUpdate() {
      if (this.form_valid) {
        this.form_model.company_id = localStorage._company_guid;
        SettingService.updateDepartment(this.form_model)
          .then((res) => {
            this.showSnackBar("update success", "success");
            this.closeDialog();
          })
          .catch((err) => {
            //this.showSnackBar(err.response.data, 'error');
            this.showSnackBar("ไม่สามารถบันทึกแผนกซ้ำกันในสาขาได้", "error");
          });
      }
    },
    // getProfilePlan() {
    //   SettingService.getProfilePlan(this.form_model)
    //     .then(res => {
    //       console.log("5555",res);
    //       this.profilePlan = res.data.content;
    //     })
    //     .catch(err => {
    //       this.showSnackBar(err.response.data, 'error');
    //     });
    // },
  },
};
</script>
